export default {
      id: "market-linked-usage",
      viewBox: "0 0 200 60",
      url: __webpack_public_path__ + "sprite.svg#market-linked",
      toString: function () {
        return this.url;
      }
    }